import { render, staticRenderFns } from "./reportDetailMore.vue?vue&type=template&id=01a35fa6&scoped=true"
import script from "./reportDetailMore.vue?vue&type=script&lang=js"
export * from "./reportDetailMore.vue?vue&type=script&lang=js"
import style0 from "./reportDetailMore.vue?vue&type=style&index=0&id=01a35fa6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a35fa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a35fa6')) {
      api.createRecord('01a35fa6', component.options)
    } else {
      api.reload('01a35fa6', component.options)
    }
    module.hot.accept("./reportDetailMore.vue?vue&type=template&id=01a35fa6&scoped=true", function () {
      api.rerender('01a35fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportCustomer/reportDetailMore.vue"
export default component.exports